var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "pos_scheduler_settings" }, [
    _c("div", { staticClass: "scheduler-top row" }, [
      _c(
        "div",
        { staticClass: "col-12 col-md-6 mb-3" },
        [
          _c("yes_no", {
            key: "POS_SCHEDULER_ENABLED",
            attrs: { title: "POS_SCHEDULER_ENABLED" },
            on: { input: _vm.emit_change },
            model: {
              value: _vm.scheduler.enabled,
              callback: function ($$v) {
                _vm.$set(_vm.scheduler, "enabled", $$v)
              },
              expression: "scheduler.enabled",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "col-12 col-md-6 mb-3" },
        [
          _c("yes_no", {
            key: "POS_SCHEDULER_PUSH_TO_MARKETS",
            attrs: { title: "POS_SCHEDULER_PUSH_TO_MARKETS" },
            on: { input: _vm.emit_change },
            model: {
              value: _vm.scheduler.push_to_markets,
              callback: function ($$v) {
                _vm.$set(_vm.scheduler, "push_to_markets", $$v)
              },
              expression: "scheduler.push_to_markets",
            },
          }),
        ],
        1
      ),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "scheduler-box" },
      [
        _c("div", { staticClass: "scheduler-box-title" }, [
          _vm._v(
            "\n            " +
              _vm._s(_vm.__t("POS_SCHEDULER_TIMES")) +
              "\n        "
          ),
        ]),
        _vm._v(" "),
        _vm._l(_vm.days, function (day, idx) {
          return _c("div", { key: day.key, staticClass: "scheduler-day-row" }, [
            _c("div", { staticClass: "scheduler-day-head" }, [
              _c("div", { staticClass: "scheduler-day-name" }, [
                _vm._v(
                  "\n                    " +
                    _vm._s(day.title) +
                    "\n                "
                ),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "scheduler-day-switch" },
                [
                  _c("yes_no", {
                    key: "scheduler_day_" + day.key,
                    attrs: { title: " " },
                    on: { input: _vm.emit_change },
                    model: {
                      value: _vm.scheduler.days[idx].enabled,
                      callback: function ($$v) {
                        _vm.$set(_vm.scheduler.days[idx], "enabled", $$v)
                      },
                      expression: "scheduler.days[idx].enabled",
                    },
                  }),
                ],
                1
              ),
            ]),
            _vm._v(" "),
            _vm.scheduler.days[idx].enabled
              ? _c(
                  "div",
                  { staticClass: "scheduler-day-body" },
                  [
                    _vm._l(
                      _vm.scheduler.days[idx].times,
                      function (time, timeIdx) {
                        return _c(
                          "div",
                          { key: timeIdx, staticClass: "scheduler-time-row" },
                          [
                            _c(
                              "div",
                              { staticClass: "input-group input-group-md" },
                              [
                                _vm._m(0, true),
                                _vm._v(" "),
                                _c("b-form-input", {
                                  attrs: { type: "time" },
                                  on: { change: _vm.emit_change },
                                  model: {
                                    value:
                                      _vm.scheduler.days[idx].times[timeIdx],
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.scheduler.days[idx].times,
                                        timeIdx,
                                        $$v
                                      )
                                    },
                                    expression:
                                      "scheduler.days[idx].times[timeIdx]",
                                  },
                                }),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "input-group-append" },
                                  [
                                    _c(
                                      "button",
                                      {
                                        staticClass: "btn btn-outline-danger",
                                        attrs: { type: "button" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.remove_time(idx, timeIdx)
                                          },
                                        },
                                      },
                                      [_c("i", { staticClass: "fal fa-trash" })]
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                          ]
                        )
                      }
                    ),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-sm btn-outline-primary mt-2",
                        attrs: { type: "button" },
                        on: {
                          click: function ($event) {
                            return _vm.add_time(idx)
                          },
                        },
                      },
                      [
                        _c("i", { staticClass: "fal fa-plus mr-1" }),
                        _vm._v(
                          "\n                    " +
                            _vm._s(_vm.__t("ADD_TIME")) +
                            "\n                "
                        ),
                      ]
                    ),
                  ],
                  2
                )
              : _vm._e(),
          ])
        }),
      ],
      2
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "input-group-prepend" }, [
      _c("span", { staticClass: "input-group-text bg-transparent" }, [
        _c("i", { staticClass: "fal fa-clock" }),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }